import { usePreview } from "./usePreview";
import { PreviewContent } from "./PreviewContent/PreviewContent";
import { Memes } from "./Memes/Memes";
import { ShadowPreview } from "../ShadowPreview/ShadowPreview";
import { Translate } from "components/common/Translate/Translate";

export const Preview = () => {
    const { canvasContainerRef } = usePreview();
    return (
        <>
            <div className="h-full w-full flex flex-col gap-6 pt-4 px-6 lg:pt-0 lg:px-0 text-black dark:text-black">
                <div className="lg:hidden flex flex-col gap-[14px] text-black dark:text-white">
                    <div>
                        <div className="text-2xl font-semibold pb-[14px]">
                            <Translate keyName="meme-generator" />
                        </div>
                        <div className="text-sm">
                            <Translate keyName="sub-title" />
                        </div>
                    </div>
                </div>
                <div className="h-full relative z-0 w-full max-w-[90%] mx-auto" ref={canvasContainerRef} id="mg-canvas-container">
                    <PreviewContent />
                </div>
                <Memes />
            </div>
            <ShadowPreview />
        </>
    );
};
